import React from 'react'
import { useSearchParams } from 'react-router-dom';
import { LecturersTable } from '../components/LecturersTable'
;
export const EvaluateLecturer = () => {
  const [explanationValues, setExplanationValues] = React.useState([]);
  const [communicationValues, setCommunicationValues] = React.useState([]);
  const [fairnessValues, setFairnessValues] = React.useState([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const name = searchParams.get("name") ? searchParams.get("name") : "";

  return (
    <>
   <div className="section-title-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <div className="content">
                  <h2 className="fw-bold">Evaluate Lecturer</h2>
                  <p>
                    The table below allows you to evaluate lecturers.
                    Please be honest and considerate in your evaluation.
                    This tool is made to help students find suitable
                    lecturers for their courses. There is zero intention to
                    disrespect or devalue lecturers or the work they do.
                    Again, please use this tool wisely and maturely.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <LecturersTable 
    readOnly={false}
    explanationValues = {explanationValues}
    setExplanationValues = {setExplanationValues}
    communicationValues = {communicationValues}
    setCommunicationValues = {setCommunicationValues}
    fairnessValues = {fairnessValues}
    setFairnessValues = {setFairnessValues}
    initialSearch = {name}
    />
    </>
    
  )
}
